export const DEBOUNCE_INTERVAL = 500;

export const POST_CODE_REGEX = /^[A-Z]{1,2}[0-9][A-Z0-9]? ?[0-9][A-Z]{2}$/i;

export const NO_ADDRESS_FOUND_LABEL = "No address found!";

export const NO_ADDRESSES = { addresses: [] };

export const SELECT_ADDRESS_LABEL = "Select address...";
